import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { setToken } from "./api";

const AuthCtx = createContext(null);

function formatErr(detail) {
  if (detail == null) return "Алдаа гарлаа";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=unauth, object=auth
  const [tenant, setTenant] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setTenant(data.tenant);
    } catch {
      setUser(null);
      setTenant(null);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.token) setToken(data.token);
      setUser(data.user);
      setTenant(data.tenant);
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: formatErr(e.response?.data?.detail) || e.message };
    }
  };

  const signup = async (payload) => {
    try {
      const { data } = await api.post("/auth/register", payload);
      if (data.token) setToken(data.token);
      setUser(data.user);
      setTenant(data.tenant);
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: formatErr(e.response?.data?.detail) || e.message };
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setToken(null);
    setUser(null);
    setTenant(null);
  };

  return (
    <AuthCtx.Provider value={{ user, tenant, login, signup, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
